import JournalImg1 from "../images/journals/journal-1.webp";
import JournalImg2 from "../images/journals/journal-2.webp";
import JournalImg3 from "../images/journals/journal-3.webp";
const journals = [
  {
    title: "A Story of Resilience",
    author: "Peak Pashmina",
    description:
      "Langtang’s earthquake left devastation, yet its people endured with courage and unity. Villages were rebuilt, lives restored, and hope sustained. This story of resilience honors those who persevered, keeping the spirit of the mountains alive for generations.",
    image: JournalImg1,
  },
  {
    title: "Living A Slow and Rich Life",
    author: "Peak Pashmina",
    description:
      "Langtang’s valley was once a place lost in time, where people lived slowly, shared stories, and stayed rooted. As younger generations leave, Peak Pashmina is committed to preserving its culture, traditions, and crafts, ensuring this rich way of life survives.",
    image: JournalImg2,
  },
  {
    title: "Being Young Between Mountains",
       author: "Peak Pashmina",
    description:
      "Anushka (ཨ་ནུ་ཤ་ཀ་), who modeled for our Langtang collection, grew up surrounded by mountains. She shares her experiences meeting people from countless countries, feeling their deep love for her homeland, and nurturing her own ambitions to travel, explore, and connect the world with her roots.",
    image: JournalImg3,
  },
];

export default journals;
